var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorIcoDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01291 10.9958C1.76243 10.9958 1.52153 10.9958 1.28063 10.9958C1.03192 10.9958 0.783208 10.9958 0.534495 10.9958C0.110973 10.9954 0.000829042 10.8885 0.000473738 10.4624C-0.000592173 8.76776 0.000473738 7.0731 0.000473738 5.37844C0.000473738 3.79531 0.000473738 2.21182 0.000473738 0.62869C0.000473738 0.56431 -0.000592173 0.499577 0.00118435 0.435196C0.0100669 0.14003 0.142595 0.00493571 0.44034 0.00247306C0.95553 -0.00174863 1.47072 0.000714023 1.98556 0.000714023C4.33625 0.000714023 6.68694 0.000714023 9.03763 0.000714023C9.39897 0.000714023 9.53114 0.129827 9.53185 0.48656C9.53257 0.984016 9.53221 1.48182 9.53221 2.00602C9.6086 2.00602 9.67113 2.00602 9.73331 2.00602C10.1835 2.00602 10.6333 2.00531 11.0835 2.00637C11.4203 2.00707 11.5557 2.14146 11.5557 2.47779C11.5557 5.56807 11.5553 8.65835 11.5546 11.7486C11.5546 12.0125 11.556 12.2763 11.5539 12.5402C11.5514 12.866 11.4185 12.9986 11.0884 12.9989C9.08701 13 7.08594 13 5.08452 13C4.23179 13 3.37941 12.9996 2.52668 12.9993C2.15077 12.9993 2.02251 12.873 2.02286 12.5064C2.02322 12.0607 2.02286 11.6149 2.0218 11.1695C2.02215 11.1182 2.01682 11.0672 2.01291 10.9958ZM0.74981 0.738454C0.74981 3.91985 0.74981 7.08823 0.74981 10.2524C3.43768 10.2524 6.11134 10.2524 8.78501 10.2524C8.78501 7.07451 8.78501 3.91035 8.78501 0.738454C6.10424 0.738454 3.43484 0.738454 0.74981 0.738454ZM10.8063 12.2637C10.8063 9.08157 10.8063 5.91319 10.8063 2.75044C10.3753 2.75044 9.95857 2.75044 9.53221 2.75044C9.53221 2.81764 9.53221 2.87006 9.53221 2.92248C9.53221 5.4386 9.53221 7.95473 9.53185 10.4709C9.53185 10.8814 9.4178 10.9954 9.00707 10.9958C6.99356 10.9961 4.98006 10.9965 2.96655 10.9968C2.90331 10.9968 2.84042 10.9968 2.77078 10.9968C2.77078 11.4309 2.77078 11.8436 2.77078 12.2637C5.4519 12.2637 8.12094 12.2637 10.8063 12.2637Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7763 2.03208C5.59279 2.03208 6.40928 2.03173 7.22576 2.03243C7.48691 2.03279 7.6571 2.17597 7.65852 2.39268C7.65994 2.6094 7.48762 2.76349 7.23145 2.76384C5.58675 2.76525 3.94169 2.76525 2.29699 2.76384C2.04259 2.76349 1.8692 2.60553 1.87311 2.38952C1.87702 2.17316 2.04721 2.03279 2.30907 2.03243C3.1316 2.03173 3.95413 2.03208 4.7763 2.03208Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7825 5.79923C5.59294 5.79923 6.40375 5.79888 7.2142 5.79958C7.48423 5.79994 7.65975 5.94699 7.65904 6.16863C7.65797 6.38992 7.48316 6.5331 7.20922 6.5331C5.60574 6.5338 4.00225 6.5338 2.39876 6.53416C2.35151 6.53416 2.3039 6.53521 2.25664 6.53275C2.02996 6.52149 1.86616 6.35931 1.87327 6.15456C1.88038 5.95719 2.04346 5.80169 2.26197 5.80064C2.91857 5.79747 3.57553 5.79923 4.23213 5.79923C4.41582 5.79923 4.59916 5.79923 4.7825 5.79923Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76139 4.64179C3.94526 4.64144 3.12912 4.64179 2.31264 4.64144C2.04865 4.64144 1.87739 4.50353 1.87313 4.28752C1.86886 4.07046 2.03905 3.91461 2.29736 3.91425C3.94739 3.91249 5.59778 3.91249 7.24781 3.91461C7.46952 3.91496 7.61413 4.02754 7.65428 4.21083C7.68732 4.3607 7.60311 4.53941 7.45033 4.60133C7.37181 4.63299 7.27872 4.63968 7.19203 4.64003C6.38193 4.6432 5.57184 4.64179 4.76139 4.64179Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51607 7.6895C3.91791 7.6895 4.32012 7.68774 4.72197 7.6902C4.9721 7.69161 5.13412 7.8355 5.13661 8.0494C5.13874 8.26154 4.9753 8.41281 4.72587 8.41352C3.91614 8.41633 3.1064 8.41598 2.29666 8.41317C2.03551 8.41211 1.86852 8.26083 1.87314 8.04377C1.87776 7.83022 2.03836 7.69196 2.29311 7.6902C2.70029 7.68774 3.10818 7.6895 3.51607 7.6895Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.70198e-7,
    y1: 13.7222,
    x2: 12.2778,
    y2: 0.722221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -0.722436,
    y1: 12.2778,
    x2: 9.74978,
    y2: 1.08334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599473,
    stopColor: "#53B4AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -0.000214814,
    y1: 12.2778,
    x2: 10.472,
    y2: 1.44444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -0.359915,
    y1: 13,
    x2: 10.8345,
    y2: 0.722222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 0.722005,
    y1: 11.9167,
    x2: 11.5553,
    y2: 0.361113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcoDocument);
export default __webpack_public_path__ + "static/media/color-ico-document.c7ab88500f90bcb36c788a4c91dc031d.svg";
export { ForwardRef as ReactComponent };